import { FunctionalComponent, h } from "@stencil/core";

interface SearchSuggestionTextProps {
  text: string;
  highlightText: string;
  lineClamp?: 1 | 2;
}

export const SearchSuggestionText: FunctionalComponent<
  SearchSuggestionTextProps
> = ({ text = "", highlightText = "", lineClamp = 2 }) => {
  const lineClampClass = `line-clamp-${lineClamp}`;
  const startIndex: number = text
    .toLowerCase()
    .indexOf(highlightText.toLowerCase());
  const queryLength: number = highlightText.length;
  let transformed = <span class={lineClampClass}>{text}</span>;

  if (startIndex >= 0 && queryLength > 0) {
    const before = text.substring(0, startIndex);
    const highlight = text.substring(startIndex, startIndex + queryLength);
    const after = text.substring(startIndex + queryLength);

    transformed = (
      <span class={lineClampClass}>
        {before}
        <strong class="highlight">{highlight}</strong>
        {after}
      </span>
    );
  }

  return transformed;
};
